<template>
  <ul class="providers">
    <li v-for="(taxonomy) in taxonomies" :key="taxonomy.id">
      <ul>
      <text-highlight :query="keywords">
        {{getTaxonomyDescription(taxonomy)}}
      </text-highlight>
        
        <li v-for="(ccd, index) in diagnosis.codes" :key="index" class="text-capitalize list__item">
          <!--{{diagnosis.id}}-->
          <span v-if="diagnosis.lo">{{diagnosis.lo}} - </span>
          <text-highlight :queries="keywords">
            {{getCcdDescriptionById(ccd)}}
          </text-highlight>
        </li>
      </ul>

      <div v-if="diagnosis.npi" class="list__sub-item">Provider:
        <router-link
            :to="{ name: 'ProviderNavigation', params: { specialty: getSpecialtyLink(provider.specialties[0].name), id: provider.id } }">
          {{ provider }}
        </router-link>
      </div>
    </li>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { getDescByCcd, getCdaTitleByDiagnosisId } from '@/data/getters.js';
  import { getProviderByNpi } from '@/api/getters/provider.js';

  export default {
    name: "ProvidersDetail",
    props: {
      taxonomies: Array,
      keywords: Array
    },
    data() {
      return {
        providerFirstName: '',
        providerLastName: '',
      }
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData',
      }),
      provider: {
        // getter
        get: function () {
          return this.providerFirstName.toLowerCase() + ' ' + this.providerLastName.toLowerCase();
        },
        // setter
        set: function (npi) {
          let provider = this.getProvider(npi);
          this.providerFirstName = provider.firstName;
          this.providerLastName = provider.lastName;
        }
      }
    },
    methods: {
      getCcdDescriptionById(id) {
        return getDescByCcd(id, this.allData);
      },
      getCdaTitle(diagnosisId) {
        return getCdaTitleByDiagnosisId(this.allData, diagnosisId);
      },
      getProvider(npi) {
        return getProviderByNpi(npi);
      },
      getSpecialtyLink(specialty) {
        return specialty.toLowerCase().replace(/\s/g, '-');
      },
    }
  }
</script>

<style scoped lang="scss">
  $color-font: #58595b;

  ul {
    list-style-type: none;
    padding: 0;
  }
  h2 {
    font-size: 1.2em;
    padding: 0.75em 1.25em;
    font-weight: bold;
    text-align: center;
  }
  .list__item {
    padding: 0.75em 1.25em;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    margin-bottom: 0.75em;
  }
  .list__sub-item {
    font-size: 0.85em;
    margin-top: 0.5em;
    color: $color-font;
  }
</style>
